import { render, staticRenderFns } from "./LeavePageDetailsTable.vue?vue&type=template&id=5f7815d2&scoped=true&"
import script from "./LeavePageDetailsTable.vue?vue&type=script&lang=js&"
export * from "./LeavePageDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7815d2",
  null
  
)

export default component.exports